import styles from "./FormSuccess.module.scss";

/**
 * Экран успешной отправки формы («отбивка») по дизайну Figma:
 * зелёная галочка, крупный заголовок, подзаголовок и текст.
 * Текст выбирается по времени (рабочее/нерабочее) в usePopupForm и
 * приходит сюда уже готовым в `reply = { title, subtitle, body }`.
 */
export default function FormSuccess({ reply }) {
  if (!reply) return null;
  const { title, subtitle, body } = reply;

  return (
    <div className={styles.Success} data-test="formSuccess">
      <span className={styles.Icon} aria-hidden="true">
        <svg
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="36" cy="36" r="35" stroke="#22B14C" strokeWidth="2" />
          <path
            d="M23 37.5L32 46L50 27"
            stroke="#22B14C"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      {title ? <div className={styles.Title}>{title}</div> : null}
      {subtitle ? <div className={styles.Subtitle}>{subtitle}</div> : null}
      {body ? <p className={styles.Text}>{body}</p> : null}
    </div>
  );
}
